import { Route, Routes } from 'react-router-dom';
import { content } from '../../components/content';
import { Wrapper } from './PageHome.style';

export type PageHomeProps = {};

export function PageHome(_props: PageHomeProps) {
  return (
    <Wrapper className='PageHome-wrapper' data-testid='PageHome-wrapper'>
      <Routes>
        <Route path='/' element={<content.Generators />} />
        <Route path='/account' element={<content.Account />} />
        <Route path='/api' element={<content.Api />} />
        <Route path='/events' element={<content.Events />} />
        <Route path='/pricing' element={<content.Pricing />} />
        <Route path='/generators/:id' element={<content.GeneratorDetails />} />
        <Route path='/generators' element={<content.Generators />} />
        <Route path='/hire-creator' element={<content.HireCreator />} />
        <Route path='/made-with-sloyd' element={<content.MadeWithSloyd />} />
        <Route path='/projects' element={<content.Projects />} />
        <Route path='/settings' element={<content.Settings />} />
        <Route path='/whats-new' element={<content.WhatsNew />} />
      </Routes>
    </Wrapper>
  );
}

export default PageHome;
